<template>
	<div class="main" id="print_popup">
		<div class="modal fade in show" tabindex="-1" role="dialog" style="display: block;">
			<div class="modal-dialog modal-dialog-scrollable">
				<div class="modal-content">
					<div class="modal-header">
						<span class="modal-title">預覽列印</span>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closePopup()">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
                        <div id="div5" class="body-by-A4">
                            <h3 style="text-align: center;">亞東科技大學{{$parent.reliefApply.smtr.toString().substr(0, 3)}}學年度第{{$parent.reliefApply.smtr.toString().substr(3, 1)}}學期<br>學生各項就學優待(減免)申請書暨切結書</h3>
                            <table class="table table-no-more table-bordered table-striped mb-none">
                                <tbody>
                                    <tr>
                                        <td data-title="姓名" class="text-left" width="4%">姓名</td>
                                        <td data-title="姓名" class="text-left" width="6%">{{$parent.stu.name}}</td>
                                        <td data-title="學號" class="text-left" width="4%">學號</td>
                                        <td data-title="學號" class="text-left" width="6%">{{$parent.stu.account}}</td>
                                        <td data-title="身分證字號" class="text-left" width="4%">身分證字號</td>
                                        <td data-title="身分證字號" class="text-left" width="6%">{{$parent.stu.idno}}</td>
                                    </tr>
                                    <tr>
                                        <td data-title="學制" class="text-left" width="4%">學制</td>
                                        <td data-title="學制" class="text-left" width="6%">
                                            {{$parent.ssymList.some(ssym => ssym.commCode == $parent.stu.ssym) ?
                                            $parent.ssymList.filter(ssym => ssym.commCode == $parent.stu.ssym)[0].commValue :
                                            ''}}
                                        </td>
                                        <td data-title="系科班級" class="text-left" width="4%">系級</td>
                                        <td data-title="系科班級" class="text-left" width="6%">
                                            {{$parent.deptList.some(dept => dept.commCode == $parent.stu.dept) ?
                                            $parent.deptList.filter(dept => dept.commCode == $parent.stu.dept)[0].commValue :
                                            ''}}
                                            {{$parent.dradeList.some(drade => drade.key == $parent.stu.drade) ?
                                            $parent.dradeList.filter(drade => drade.key == $parent.stu.drade)[0].value :
                                            ''}}
                                            {{$parent.dradeClassList.some(dradeClass => dradeClass.key == $parent.stu.dradeClass) ?
                                            $parent.dradeClassList.filter(dradeClass => dradeClass.key == $parent.stu.dradeClass)[0].value :
                                            ''}}
                                        </td>
                                        <td data-title="聯絡電話" class="text-left" width="4%">聯絡電話</td>
                                        <td data-title="聯絡電話" class="text-left" width="6%">{{$parent.stu.phone}}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <table class="table table-no-more table-bordered table-striped mb-none">
                                <tbody>
                                    <tr>
                                        <td data-title="申請類別(請勾選)" style="text-align: center;">申請類別(請勾選)</td>
                                        <td data-title="應繳證明文件" style="text-align: center;">【應繳證明文件】 &ensp;
                                            <input type="checkbox" disabled :checked="($parent.stu.drade == 1 && $parent.reliefApply.smtr.toString().substr(3, 1) == '1') || (JSON.stringify(this.sessionData) == '{}')">新生、轉學生另繳回學雜費繳費單
                                        </td>
                                    </tr>
                                    <tr>
                                        <td data-title="申請類別(家庭年收入)" class="text-left" width="5%">
                                            <input type="checkbox" disabled :checked="$parent.reliefApply.reliefType == 'A3' || $parent.reliefApply.reliefType == 'A4'">
                                                軍公教遺族子女(新生須另填部頒申請書報部核准)<br>
                                            <input type="checkbox" disabled style="margin-left: 15px" :checked="$parent.reliefApply.reliefType == 'A3'">
                                                全公費<br>
                                            <input type="checkbox" disabled style="margin-left: 15px" :checked="$parent.reliefApply.reliefType == 'A4'">
                                                半公費<br>
                                            <input type="checkbox" disabled :checked="$parent.reliefApply.reliefType == 'A2'">
                                                給卹期滿軍公教遺族子女
                                        </td>
                                        <td data-title="應繳證明文件" class="text-left" width="6%">
                                            <input type="checkbox" disabled :checked="$parent.reliefApply.reliefType == 'A2' || $parent.reliefApply.reliefType == 'A3' || $parent.reliefApply.reliefType == 'A4'">撫卹令、年撫卹金證書、核定函（須有學生名字，查驗正本，繳交影本)<br>
                                            <input type="checkbox" disabled :checked="$parent.reliefApply.reliefType == 'A2' || $parent.reliefApply.reliefType == 'A3' || $parent.reliefApply.reliefType == 'A4'">3個月內戶籍謄本正本或新式戶口名簿影本（含詳細記事）
                                        </td>
                                    </tr>
                                    <tr>
                                        <td data-title="申請類別(家庭年收入)" class="text-left">
                                            <input type="checkbox" disabled :checked="$parent.reliefApply.reliefType == 'A5'">現役軍人子女(減免3/10學費)
                                        </td>
                                        <td data-title="應繳證明文件" class="text-left">
                                            <input type="checkbox" disabled :checked="$parent.reliefApply.reliefType == 'A5'">家長在職服務相關證明或在營服役證明<br>
                                            <input type="checkbox" disabled :checked="$parent.reliefApply.reliefType == 'A5'">3個月內戶籍謄本正本或新式戶口名簿影本(含詳細記事）
                                        </td>
                                    </tr>
                                    <tr>
                                        <td data-title="申請類別(家庭年收入)" class="text-left">
                                            <input type="checkbox" disabled :checked="$parent.reliefApply.reliefType == 'A1'">原住民學生(依部頒規定標準核減)
                                        </td>
                                        <td data-title="應繳證明文件" class="text-left">
                                            <input type="checkbox" disabled :checked="$parent.reliefApply.reliefType == 'A1'">3個月內戶籍謄本正本或新式戶口名簿影本(含詳細記事)
                                        </td>
                                    </tr>
                                    <tr>
                                        <td data-title="申請類別(家庭年收入)" class="text-left">
                                            <input type="checkbox" disabled :checked="$parent.reliefApply.reliefType == 'A7' || $parent.reliefApply.reliefType == 'A8' || $parent.reliefApply.reliefType == 'A9'">身心障礙學生　
                                            <input type="checkbox" disabled :checked="$parent.reliefApply.reliefType == 'AA' || $parent.reliefApply.reliefType == 'AB' || $parent.reliefApply.reliefType == 'AC'">身心障礙人士子女
                                        </td>
                                        <td data-title="應繳證明文件" class="text-left" rowspan="2">
                                            <input type="checkbox" disabled :checked="$parent.reliefApply.reliefType == 'A7' || $parent.reliefApply.reliefType == 'A8' || $parent.reliefApply.reliefType == 'A9' || $parent.reliefApply.reliefType == 'AA' || $parent.reliefApply.reliefType == 'AB' || $parent.reliefApply.reliefType == 'AC'">身心障礙手冊或身心障礙學生鑑輔會證明文件（查驗正本，繳交影本）<br>
                                            <input type="checkbox" disabled :checked="$parent.reliefApply.reliefType == 'A7' || $parent.reliefApply.reliefType == 'A8' || $parent.reliefApply.reliefType == 'A9' || $parent.reliefApply.reliefType == 'AA' || $parent.reliefApply.reliefType == 'AB' || $parent.reliefApply.reliefType == 'AC'">3個月內戶籍謄本正本或新式戶口名簿影本（含詳細記事）<br>
                                            ※家庭年所得需未超過220萬元，統一由教育部查核※
                                        </td>
                                    </tr>
                                    <tr>
                                        <td data-title="申請類別(家庭年收入)" class="text-left">
                                            <input type="checkbox" disabled :checked="$parent.reliefApply.reliefType == 'A7'|| $parent.reliefApply.reliefType == 'AA'">重度、極重度(學雜費全免)<br>
                                            <input type="checkbox" disabled :checked="$parent.reliefApply.reliefType == 'A8'|| $parent.reliefApply.reliefType == 'AB'">中度(減免7/10學雜費)<br>
                                            <input type="checkbox" disabled :checked="$parent.reliefApply.reliefType == 'A9'|| $parent.reliefApply.reliefType == 'AC'">輕度(減免4/10學雜費)
                                        </td>
                                    </tr>
                                    <tr>
                                        <td data-title="申請類別(家庭年收入)" class="text-left">
                                            <input type="checkbox" disabled :checked="$parent.reliefApply.reliefType == 'AD'">低收入戶學生(減免全部學雜費)
                                        </td>
                                        <td data-title="應繳證明文件" class="text-left">
                                            <input type="checkbox" disabled :checked="$parent.reliefApply.reliefType == 'AD'">低收入戶證明文件（須有學生名字)
                                            </td>
                                    </tr>
                                    <tr>
                                        <td data-title="申請類別(家庭年收入)" class="text-left">
                                            <input type="checkbox" disabled :checked="$parent.reliefApply.reliefType == 'AF'">中低收入戶學生(減免6/10學雜費)
                                        </td>
                                        <td data-title="應繳證明文件" class="text-left">
                                            <input type="checkbox" disabled :checked="$parent.reliefApply.reliefType == 'AF'">中低收入戶證明文件（須有學生名字）
                                        </td>
                                    </tr>
                                    <tr>
                                        <td data-title="申請類別(家庭年收入)" class="text-left">
                                            <input type="checkbox" disabled :checked="$parent.reliefApply.reliefType == 'A6'">特殊境遇家庭子女孫子女(減免6/10學雜費)
                                        </td>
                                        <td data-title="應繳證明文件" class="text-left">
                                            <input type="checkbox" disabled :checked="$parent.reliefApply.reliefType == 'A6'">特殊境遇家庭身分證明文件（查驗正本，繳交影本）<br>
                                            <input type="checkbox" disabled :checked="$parent.reliefApply.reliefType == 'A6'">3個月內戶籍謄本正本或新式戶口名簿影本（含詳細記事）
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <table class="table table-no-more table-bordered table-striped mb-none">
                                <tbody>
                                    <tr>
                                        <td data-title="稱謂" style="text-align: center;" width="3%">稱謂</td>
                                        <td data-title="姓名" style="text-align: center;" width="5%">姓名</td>
                                        <td data-title="身分證字號" style="text-align: center;" width="5%">身分證字號</td>
                                        <td data-title="職業" style="text-align: center;" width="5%">職業</td>
                                    </tr>
                                    <tr>
                                        <td data-title="家長" style="text-align: center;" width="3%">
                                            {{$parent.reliefKinshipList.some(reliefKinship => reliefKinship.commCode == $parent.reliefApply.kinshipList[0].kinshipType) ?
                                            $parent.reliefKinshipList.filter(reliefKinship => reliefKinship.commCode == $parent.reliefApply.kinshipList[0].kinshipType)[0].commValue :
                                            ''}}
                                        </td>
                                        <td data-title="簽名" style="text-align: center;" width="5%">
                                            {{$parent.reliefApply.kinshipList[0].status == 'P' ? '歿' : $parent.reliefApply.kinshipList[0].status == 'O' ? '無' :  $parent.reliefApply.kinshipList[0].name}}
                                        </td>
                                        <td data-title="蓋章" style="text-align: center;" width="3%">
                                            {{$parent.reliefApply.kinshipList[0].status == 'P' || $parent.reliefApply.kinshipList[0].status == 'O'? '' : $parent.reliefApply.kinshipList[0].idNo}}
                                        </td>
                                        <td data-title="身分證字號" style="text-align: center;" width="5%">
                                            {{$parent.reliefApply.kinshipList[0].status == 'P' || $parent.reliefApply.kinshipList[0].status == 'O'? '' :
                                            $parent.reliefKinshipOccupationList.some(o => o.commCode == $parent.reliefApply.kinshipList[0].occupationType) ?
                                            $parent.reliefKinshipOccupationList.filter(o => o.commCode == $parent.reliefApply.kinshipList[0].occupationType)[0].commCode == 'O' ?
                                             $parent.reliefApply.kinshipList[0].occupationValue :
                                             $parent.reliefKinshipOccupationList.filter(o => o.commCode == $parent.reliefApply.kinshipList[0].occupationType)[0].commValue :
                                            ''}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td data-title="家長" style="text-align: center;" width="3%">
                                            {{$parent.reliefKinshipList.some(reliefKinship => reliefKinship.commCode == $parent.reliefApply.kinshipList[1].kinshipType) ?
                                            $parent.reliefKinshipList.filter(reliefKinship => reliefKinship.commCode == $parent.reliefApply.kinshipList[1].kinshipType)[0].commValue :
                                            '　'}}
                                        </td>
                                        <td data-title="簽名" style="text-align: center;" width="5%">
                                            {{$parent.reliefApply.kinshipList[1].status == 'P' ? '歿' : $parent.reliefApply.kinshipList[1].status == 'O' ? '無' :  $parent.reliefApply.kinshipList[1].name}}
                                        </td>
                                        <td data-title="蓋章" style="text-align: center;" width="3%">
                                            {{$parent.reliefApply.kinshipList[1].status == 'P' || $parent.reliefApply.kinshipList[1].status == 'O'? '' : $parent.reliefApply.kinshipList[1].idNo}}
                                        </td>
                                        <td data-title="身分證字號" style="text-align: center;" width="5%">
                                            {{$parent.reliefApply.kinshipList[1].status == 'P' || $parent.reliefApply.kinshipList[1].status == 'O'? '' :
                                            $parent.reliefKinshipOccupationList.some(o => o.commCode == $parent.reliefApply.kinshipList[1].occupationType) ?
                                            $parent.reliefKinshipOccupationList.filter(o => o.commCode == $parent.reliefApply.kinshipList[1].occupationType)[0].commCode == 'O' ?
                                             $parent.reliefApply.kinshipList[1].occupationValue :
                                             $parent.reliefKinshipOccupationList.filter(o => o.commCode == $parent.reliefApply.kinshipList[1].occupationType)[0].commValue :
                                            ''}}
                                        </td>

                                    </tr>
                                </tbody>
                            </table>
                            <p style="margin-top:15px; font-weight: 800;">
                                本人申請上述就學優待減免，保證在校享有優待期間，放棄申領政府發給之其他教育補助，如有重複請領，願負法律責任。</p>
                            <table class="table mb-none table-no-border">
                                <tbody>
                                    <tr>
                                        <td data-title="立切結書人" class="text-left">
                                          <div style="display: flex;">
                                            <div style="height: 50px;display: flex;">
                                              <span style="align-self: flex-end;">
                                                立切結書人：家長簽名_____________________
                                              </span>
                                            </div>
                                            <div class="square">
                                              <span style="align-self: center">
                                                蓋章
                                              </span>
                                            </div>
                                          </div>
                                        </td>
                                        <td data-title="申請學生" class="text-left">
                                          <div style="display: flex;">
                                            <div style="height: 50px;display: flex;">
                                              <span style="align-self: flex-end;">
                                                學生簽名______________________
                                              </span>
                                            </div>
                                            <div class="square">
                                              <span style="align-self: center">
                                                蓋章
                                              </span>
                                            </div>
                                          </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td data-title="住家" class="text-left" colspan="2">
                                            <span class="s_right">
                                              {{$parent.reliefApply.crDate != "" ? new Date($parent.reliefApply.crDate).getFullYear() - 1911 : ''}} 年　{{$parent.reliefApply.crDate != "" ? new Date($parent.reliefApply.crDate).getMonth() + 1 : ''}}　月　{{$parent.reliefApply.crDate != "" ? new Date($parent.reliefApply.crDate).getDate() : ''}}　日
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <hr class="no-soild">
                            <span class="s_right">SA-1-04</span>
                        </div>
					</div>
					<div class="modal-footer">
                        <span style="font-size: 20px;font-weight: bold">請將此切結書列印並簽名後，以拍照或掃描的方式上傳檔案至切結書欄位。</span>
						<button type="button" class="btn btn-primary" @click="handlePrint">列印</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Printd } from 'printd'
export default {
  mounted(){
	},
	data(){
		return {
		}
	},
	methods:{
		handlePrint() {
			const d = new Printd();
			d.print(document.getElementById('div5'),[`
				.body-by-A4 p{line-height:1;}
				.body-by-A4 .table-bordered{border-collapse: collapse; border: 1px solid #ddd;}
				.body-by-A4 .table-bordered tr>td{ padding: 0; line-height: 1.5; vertical-align: top; border: 1px solid #ddd;  }
                .s_right { text-align: right; display: block;}
                hr.no-soild { height: 0; border-bottom: 1px solid #666666; margin: 8px 0px 0px 0px;}
                .table-striped>tbody>tr:nth-of-type(odd) {background-color: #f9f9f9;}
        .square { width: 50px; height: 50px; border: #000000 1px solid; display: flex;justify-content: center;}
			`])
            this.$parent.showPrintPopup(false);
            this.$parent.isShowPrintBtn = false;
            bootbox.alert("以拍照或掃描的方式上傳檔案至切結書欄位並送出，才算完成申請。\n若無法當下完成切結書上傳可透過學雜費減免申請查詢功能，完成最後上傳步驟。");
		},
		closePopup() {
			this.$parent.showPrintPopup(false);
		}
	}
}
</script>
<style>
@media (min-width: 768px){
	#print_popup .modal-dialog {
		width: 720px;
		margin: 30px auto;
	}
}

@media (min-width: 992px){
	#print_popup .modal-dialog {
		width: 880px;
		margin: 30px auto;
	}
}

@media (min-width: 1200px){
	#print_popup .modal-dialog {
		width: 1200px;
		margin: 30px auto;
	}
}

#print_popup .modal-dialog-scrollable {
    height: calc(100% - (30px + 5px));
}

#print_popup .modal-dialog-scrollable .modal-content {
    display: grid;
    height: 100%;
    overflow: hidden;
}

#print_popup .modal-dialog-scrollable .modal-body {
    overflow-y: auto;
}

.s_right {
    text-align: right;
    display: block;
}

hr.no-soild {
    height: 0;
    border-bottom: 1px solid #666666;
    margin: 8px 0px 0px 0px;
}

.square {
  width: 50px;
  height: 50px;
  border: #000000 1px solid;
  display: flex;
  justify-content: center;
}

@media screen {
  #print {
    display: none;
   }
}

@media print {
 body * {
  visibility:hidden;
  }
  #print, #print * {
    visibility:visible;
  }
  #print {
    position:absolute;
    left:0;
    top:0;
  }
}
</style>
